export default "__VITE_ASSET__C7p1MFDo__"